<template>
  <div class="d-flex justify-content-between alignitem-center">
    <div v-if="limit > 1" class="mr-gd-2">
      <b-button
        variant="default"
        style="height: fit-content;"
        :style="`width:${languageEngine === 'th' ? '130' : '110'}px;`"
        @click="$emit('toggleMultiSelect')"
        v-show="fileSelectedLength !== filelistLength || filelistLength === 0"
      >
        <span><i class="far fa-check mr-2"></i>{{$t('engine.filemanager.selectAll', languageEngine)}}</span>
      </b-button>
      <b-button
        variant="default"
        style="height: fit-content;"
        :style="`width:${languageEngine === 'th' ? '200' : '110'}px;`"
        @click="$emit('clear')"
        v-show="fileSelectedLength === filelistLength && filelistLength !== 0"
      >
        <span><i class="far fa-times mr-2"></i>{{$t('engine.filemanager.deselectAll', languageEngine)}}</span>
      </b-button>
    </div>

    <div
      class="d-flex align-items-center"
      style="width: 100%; position: relative"
    >
      <span
        style="cursor: pointer; position: absolute; left: 10px"
        @click="$emit('callback')"
        ><i class="far fa-search text-muted"></i
      ></span>
      <b-form-input
        class="search px-gd-4"
        v-model="options.name"
        @keyup.enter.native="$emit('callback')"
        :placeholder="$t('engine.filemanager.search', languageEngine)"
      />
      <span
          v-if="options.name != ''"
        style="cursor: pointer; position: absolute; right: 10px"
        @click="(options.name = ''), $emit('callback')"
      >
        <i class="fas fa-times-circle text-muted"></i>
      </span>
    </div>

    <!-- <b-input-group>
      <b-input-group-prepend>
        <b-button
          variant="outline-secondary"
          class="border-right-0"
          style="border: 1px solid #ced4da"
          @click="$emit('callback')"
        >
          <i class="far fa-search"></i>
        </b-button>
      </b-input-group-prepend>

      <b-form-input
        class="border-right-0 border-left-0 search"
        v-model="options.name"
        @keyup.enter.native="
            $emit('callback')
        "
        placeholder="Search..."
      />
      <b-input-group-append>
        <b-button
          variant="outline-secondary"
          class="border-left-0"
          style="border: 1px solid #ced4da"
          @click="options.name = '',$emit('callback')
          "
        >
          <span v-if="options.name !== ''">
            <i class="far fa-times"></i>
          </span>
        </b-button>
      </b-input-group-append>
    </b-input-group> -->

    <div class="d-flex ml-gd-2">
      <b-button
        @click="$emit('setDisplay', 'thumbnail')"
        :variant="displayType == 'thumbnail' ? 'outline-blue' : 'default'"
      >
        <i class="fal fa-th-large fs-16"></i>
      </b-button>
      <b-button
        @click="$emit('setDisplay', 'list')"
        :variant="displayType == 'list' ? 'outline-blue' : 'default'"
        class="ml-gd-half"
      >
        <i class="fal fa-bars fs-16"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    })
  },
  props: {
    fileSelectedLength: {
      type: [String, Number],
      default: "",
    },
    filelistLength: {
      type: [String, Number],
      default: "",
    },
    limit: {
      type: [String, Number],
      default: "",
    },
    displayType: {
      type: String,
      default: "thumbnail",
    },
    options: {
      type: Object,
      default: () => {
        return {
          p: 1,
          take: 50,
          name: "",
        };
      },
    },
  },
};
</script>

<style></style>
